import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ReactComponent as EditIcon } from '../../assets/img/icons/edit.svg'
import { ReactComponent as RemoveIcon } from '../../assets/img/icons/remove.svg'
import { openModalWindow } from '../../store/ModalWindowData/action'
import { getEventsRequest } from '../../store/Events/action'
import { ApplicationState } from '../../store'
import { getPatients } from '../../selectors/patients'
import { getInstitutionsSelector } from '../../selectors/institutions'
import { fetchRequest } from '../../store/Patients/action'
import { DEFAULT_PATIENT_FILTERS } from '../../store/Patients/constants'
import greenHills from '../../assets/img/greenHills.svg'
import '../../assets/scss/layouts/greenHills.scss'
import { EventDto } from '../../store/Events/types'

const EventsPage: React.FC = () => {
  const dispatch = useDispatch()
  const events = useSelector((state: ApplicationState) => state.events.all)
  const loading = useSelector((state: ApplicationState) => state.events.loading)
  const patients = useSelector(getPatients)
  const institutions = useSelector(getInstitutionsSelector)

  useEffect(() => {
    dispatch(getEventsRequest())
    dispatch(fetchRequest(1, DEFAULT_PATIENT_FILTERS))
  }, [])

  const formatDate = (iso: string): string => {
    if (!iso) return '—'
    const d = new Date(iso)
    return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  }

  const openCreate = () =>
    dispatch(openModalWindow('createEvent', { event: null, patients, institutions }))

  const openEdit = (event: EventDto) =>
    dispatch(openModalWindow('editEvent', { event, patients, institutions }))

  const openDelete = (event: EventDto) =>
    dispatch(openModalWindow('deleteEvent', { id: event.id, title: event.title }))

  return (
    <div>
      <div className="card-box patient-info">
        <div className="box-title flex justify-between align-center" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 24px 16px' }}>
          <h3 style={{ margin: 0 }}>Events</h3>
          <button
            className="g_btn g_btn--primary"
            type="button"
            onClick={openCreate}
          >
            Create event
          </button>
        </div>

        {loading && <div style={{ padding: '16px 24px' }}>Loading...</div>}

        {!loading && events.length === 0 && (
          <div style={{ padding: '24px', color: '#888' }}>No events found. Create your first event.</div>
        )}

        {events.length > 0 && (
          <div>
            <div className="voucher-code" style={{ fontWeight: 600, borderBottom: '1px solid #eee' }}>
              <span className="statistic-item" style={{ flex: 2 }}>Title</span>
              <span className="statistic-item" style={{ flex: 2 }}>Start</span>
              <span className="statistic-item" style={{ flex: 2 }}>End</span>
              <span className="statistic-item" style={{ flex: 1 }}>Patients</span>
              <span className="statistic-item" style={{ flex: 1 }}>Institutions</span>
              <span className="statistic-item" style={{ flex: 1 }}></span>
            </div>
            {events.map((event: EventDto) => (
              <div key={event.id} className="voucher-code" style={{ borderBottom: '1px solid #f5f5f5', alignItems: 'center' }}>
                <span className="statistic-item" style={{ flex: 2 }}>{event.title}</span>
                <span className="statistic-item" style={{ flex: 2 }}>{formatDate(event.startDate)}</span>
                <span className="statistic-item" style={{ flex: 2 }}>{formatDate(event.endDate)}</span>
                <span className="statistic-item" style={{ flex: 1 }}>{event.userIds?.length ?? 0}</span>
                <span className="statistic-item" style={{ flex: 1 }}>{event.institutionIds?.length ?? 0}</span>
                <span className="statistic-item" style={{ flex: 1, display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <EditIcon
                    className="action-btn-svg"
                    style={{ cursor: 'pointer' }}
                    onClick={() => openEdit(event)}
                  />
                  <RemoveIcon
                    className="action-btn-svg"
                    style={{ fill: '#BA1717', cursor: 'pointer' }}
                    onClick={() => openDelete(event)}
                  />
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
      <img className="greenHills" src={greenHills} alt="" />
    </div>
  )
}

export default EventsPage
